import React from 'react'

import * as S from './styles'

function ThermPetAnjo ({ show, loading, onHandleAcceptTherm, onHandleClose }) {
  return (
    <S.Container show={show}>
      <S.Backdrop onClick={onHandleClose} />
      <S.ModalContent>
        <S.ModalHeader>
          <S.ModalClose onClick={onHandleClose} />
        </S.ModalHeader>

        <S.ModalBody>
          <S.Paragraph>Queremos facilitar sua navegação!</S.Paragraph>

          <S.Paragraph>
          Agora você pode acessar a plataforma <strong>PetAnjo</strong> com o mesmo login da <strong>Cobasi</strong>. <br />
          Para que isso aconteça, precisaremos compartilhar com a PetAnjo os seguintes dados: seu <strong>nome</strong>, <strong>ID</strong> e <strong>email</strong>, necessários para validação e continuação do seu acesso por lá.
          </S.Paragraph>

          <S.Paragraph>
          Não se preocupe, seus dados estarão protegidos nesta transação.
          </S.Paragraph>

          <S.Paragraph>
          Você concorda com o compartilhamento dos dados listados acima?
          </S.Paragraph>

          <S.Paragraph>Caso não concorde, vamos apenas te direcionar para a página principal, onde você deverá criar ou realizar um novo login.</S.Paragraph>

          <S.Actions>
            <S.Button disabled={loading} onClick={async () => await onHandleAcceptTherm(false)} outline>Não concordo</S.Button>
            <S.Button disabled={loading} onClick={async () => await onHandleAcceptTherm(true)}>Concordo</S.Button>
          </S.Actions>
        </S.ModalBody>
      </S.ModalContent>
    </S.Container>
  )
}

export default ThermPetAnjo
